const NewsPagePrevIcon = (
  <svg
    width="36"
    height="38"
    viewBox="0 0 36 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.491142 19.0386C0.491142 28.804 8.33434 36.7127 18 36.7127C27.6657 36.7127 35.5089 28.804 35.5089 19.0386C35.5089 9.27326 27.6657 1.36456 18 1.36456C8.33434 1.36456 0.491142 9.27326 0.491142 19.0386Z"
      fill="white"
      stroke="#9F9F9F"
      strokeWidth="0.982287"
    />
    <path
      d="M21.3332 12.3108L14.6666 19.0386L21.3332 25.7665"
      stroke="#444444"
      strokeWidth="1.47343"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default NewsPagePrevIcon;
